<template>
  <div class="custom-options d-flex">
    <div
      v-if="elipseColor"
      class="custom-size"
      :style="{ backgroundColor: elipseColor}"
    />
    <div
      class="d-flex flex-column"
    >
      <div>
        <p class="text-secondary">
          {{ title }}
        </p>
      </div>
      <div>
        <b-spinner
          v-if="loading"
          variant="primary"
          label="Spinning"
        />
        <p
          v-else
          class="text-semi-bold"
        >
          {{ description }}
        </p>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InfoCard',
  props: {
    elipseColor: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: [String, Number],
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

}
</script>

<style lang="scss" scoped >

@import "@/../GjirafaFront/style/theme.scss";
.custom-options {
  width: 220px;
  height: 90px;
  background-color: $white;
  border-radius: 10px;
  padding: 14px;
  border: 2px solid $gray-300;
  margin-block: 6px;
}

.text-semi-bold{
  font-size: 17px;
  font-weight: 500;
}

.custom-size{
  width: 8px;
  height: 8px;
  border-radius: 10px;
  margin-top: 8px;
  margin-right: 5px;
}

</style>
